import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Mail } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 border-t border-border/50 bg-[#f3f1ec]">
      <div className="container-heritage">
        <div className="grid md:grid-cols-4 gap-12 items-start">
          
          {/* LEFT - BRAND + ADDRESS */}
          <div className="space-y-4 text-left">
            <Link to="/">
              <h3 className="font-serif text-xl font-medium text-foreground">
                Anand Fashion
              </h3>
            </Link>

            <p className="text-sm text-muted-foreground">
              Proprietor: Anand Goswani
            </p>

            <a
              href="https://www.google.com/maps/search/?api=1&query=Anand+Fashion+Udaipur"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-sm text-muted-foreground hover:text-foreground transition"
            >
              📍 D-2, Bhopalpura, Near Gattani Hospital,
              <br />
              Udaipur, Rajasthan – 313001
            </a>

            <a
              href="tel:+919214456664"
              className="block text-sm text-muted-foreground hover:text-foreground transition"
            >
              📞 +91 9214456664
            </a>
          </div>

          {/* NEW - QUICK LINKS (IMPORTANT FOR ADSENSE) */}
          <div className="space-y-4 text-left">
            <h4 className="font-serif text-lg">Quick Links</h4>

            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <Link to="/about" className="hover:text-foreground transition">
                About Us
              </Link>
              <Link to="/contact" className="hover:text-foreground transition">
                Contact Us
              </Link>
              <Link to="/privacy" className="hover:text-foreground transition">
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:text-foreground transition">
                Terms & Conditions
              </Link>
            </div>
          </div>

          {/* CENTER - PARSHWEBCRAFT CREDIT */}
          <div className="flex flex-col items-center justify-center text-center space-y-3">
            <div className="line-gold w-16" />

            <p className="text-sm text-muted-foreground">Powered by</p>

            <a
              href="https://www.parshwebcraft.in"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-foreground hover:underline transition"
            >
              ParshWebCraft
            </a>

            <p className="text-xs text-muted-foreground/70 pt-2">
              © {currentYear} Anand Fashion — A Legacy of Style
            </p>
          </div>

          {/* RIGHT - SOCIAL + NEWSLETTER */}
          <div className="text-right space-y-6">
            <div>
              <h4 className="font-serif text-lg mb-3">Connect</h4>

              <div className="flex justify-end gap-6">
                <a
                  href="https://www.instagram.com/anandfashionudaipur/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition"
                >
                  <Instagram size={20} />
                </a>

                <a
                  href="https://wa.me/919214456664"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground transition"
                >
                  <MessageCircle size={20} />
                </a>

                <a
                  href="mailto:goswamianand82@gmail.com"
                  className="text-muted-foreground hover:text-foreground transition"
                >
                  <Mail size={20} />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-serif text-lg mb-3">Newsletter</h4>
              <div className="flex justify-end">
                <input
                  type="email"
                  placeholder="Your email"
                  className="border px-3 py-2 w-48 text-sm outline-none bg-white"
                />
                <button className="bg-black text-white px-4 py-2 text-sm">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;